<div class="opacity-layer" *ngIf="isActive" [@display]="isActive" (@display.start)="animationStarted($event)" (@display.done)="animationDone($event)" >
